import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Text, Form, Flex, Colors, Box, Tooltip } from '@pinchenterprisesnpm/friday-ui'
import { updateSpecificDay } from '@src/ui/components/Admin/Shifts/ShiftEditDuplicate/utils'
import { IScheduleSectionFormValues } from '@src/features/shift-post-v2/steps/shift-details-step/components/schedule-section/schedule-section.types'
import { TDay } from '@src/ui/components/Admin/Shifts/ShiftEditDuplicate/utils/types'
import { connect, FormikProps } from 'formik'

const { Checkbox } = Form

interface INewHireStartDayProps {
  formik?: FormikProps<IScheduleSectionFormValues>
  day: TDay
  isEditable?: boolean
}

export const NewHireStartDay = connect<INewHireStartDayProps>(
  ({ formik, day, isEditable = true }) => {
    const { values, setFieldValue } = formik
    const { days } = values

    const handleChange = (e: React.MouseEvent<HTMLDivElement>) => {
      // Stop propagation of the event to prevent the checkbox from being checked
      e.preventDefault()
      e.stopPropagation()

      const value = !day.starting_day

      const updatedDays = updateSpecificDay(days, day.id, {
        starting_day: value,
        is_dirty: true,
      })

      setFieldValue('days', updatedDays)
    }

    return (
      <Flex alignItems='center'>
        {/* Box used as a hack for an issue with the checkbox */}
        <Box onClick={isEditable ? handleChange : undefined}>
          <Checkbox
            value={day.starting_day}
            isDisabled={!isEditable}
            borderRadius='4px'
            borderWidth='2px'
            borderColor={Colors.muted}
            backgroundColor={Colors.white}
          />
        </Box>

        <Text mt={0} mb='2px' color='primary' fontWeight='bold' fontSize='small'>
          New Hire Start Date
        </Text>

        <Box mb='2px' ml='xs'>
          <Tooltip text='New hires can start on this day' placement='bottom'>
            <FontAwesomeIcon icon={faCircleInfo} color={Colors.muted} />
          </Tooltip>
        </Box>
      </Flex>
    )
  }
)
